<template>
    <div class="item-volo-hotel-ritorno" v-if="flight.voli">
        <ul>
            <li style="min-height: 30px; border-left: 0;">
                <div :class="(isDestinazione? 'flight-dest-icon' : 'flight-back-icon') + ' has-icon d-flex justify-content-between'">
                    <div>
                        <p>{{isDestinazione? destinationAirport : departureAirport}}</p>
                    </div>
                    <div class="tools">
                        <button v-if="showInfoIcon" class="btn info" @click="onClickInfo"><div></div></button>
                    </div>
                </div>
                <div class="info">
                    <span>{{isDestinazione? destinationAirportSigla : departureAirportSigla}} - {{time}}</span>
                </div>
            </li>
        </ul>
        <ModalFlightDetail :value=flight ref="modalFlightDetail" :selected="true"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {simpleTimeFormatter} from '../../../../utils/formatter'
import {airportName} from '../../../../utils/helper'
import ModalFlightDetail from '../modals/ModalFlightDetail'

export default {
  name: 'ItemVoloRitorno',
  components: {ModalFlightDetail},
  props: {
    isDestinazione: {
      type: Boolean,
      value: false
    }
  },
  data () {
    return {
      showInfoIcon: true
    }
  },
  computed: {
    isTourFlight () {
      return !this.getFlightTo().voli && this.getTour().flights
    },
    flight () {
      return this.isTourFlight ? this.getTour().flights[0] : this.getFlightTo()
    },
    primoVolo () {
      return this.flight.voli[this.isTourFlight ? (this.flight.voli.length - 1) : 0]
    },
    ultimoVolo () {
      return this.flight.voli[this.isTourFlight ? 0 : (this.flight.voli.length - 1)]
    },
    departureAirport () {
      return airportName(this.primoVolo.partenza.aeroporto.airport.objA)
    },
    departureAirportSigla () {
      return this.primoVolo.destinazione.aeroporto.airport.objB
    },
    destinationAirport () {
      return airportName(this.ultimoVolo.destinazione.aeroporto.airport.objA)
    },
    destinationAirportSigla () {
      return this.ultimoVolo.destinazione.aeroporto.airport.objB
    },
    time () {
      const time = this.isDestinazione ? this.ultimoVolo.destinazione.dataOra.time.time : this.primoVolo.partenza.dataOra.time.time
      return simpleTimeFormatter(time[0], time[1])
    },
    vector () {
      return this.flight ? this.flight.vector.objA : ''
    }
  },
  methods: {
    ...mapGetters(['getTour', 'getFlightTo']),
    onClickInfo () {
      this.$refs.modalFlightDetail.open()
    }
  },
  created () {
    this.showInfoIcon = !this.isTourFlight
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemVoloRitorno.vue